
















































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

import { Surface } from '@/components/atoms';
import CloseModalIcon from '@/components/icons/CloseModal.vue';
import { TextField } from '@/components/atoms';
import { FilledButton } from '@/components/molecules';

import eventBus from '@/utils/eventBus';

@Component({
  components: {
    CloseModalIcon,
    Surface,
    TextField,
    FilledButton
  }
})
export default class SendTestEmailModal extends Vue {
  @Prop(String) title!: string;
  @Prop(String) subtitle!: string;
  @Prop(String) description!: string;

  textFieldLabel: string = 'Confirm email';
  sendSuccess: boolean = false;

  emailAddress: string = '';

  created() {
    document.onkeydown = this.handleOnkeydown;
  }

  @Watch('$route')
  onRouteChange() {
    this.onClose();
  }

  onClose() {
    eventBus.$emit('closeModal');
  }

  handleOnkeydown({ key }: KeyboardEvent) {
    if (key === 'Escape') {
      this.onClose();
    }
  }

  async handleSubmit() {
    if (this.emailAddress) {
      this.textFieldLabel = 'Email sent to';
      this.sendSuccess = true;
    }
  }
}
